import {LangKeyType} from '../../../../provider/locale/translation/type';
import {LocalPackServicesEnum} from '../../../../service/local-pack/local-pack-type';

export const localPackQueryTableLocalizationMap: Record<LocalPackServicesEnum, LangKeyType> = {
    [LocalPackServicesEnum.desktop]: 'LOCAL_PACK__QUERY_RESULTS_TABLE__WEB',
    [LocalPackServicesEnum.mobile]: 'LOCAL_PACK__QUERY_RESULTS_TABLE__MOBILE',
    [LocalPackServicesEnum.maps]: 'LOCAL_PACK__QUERY_RESULTS_TABLE__MAPS',
};
